import type { DocNode } from '@atlaskit/adf-schema/doc';

/**
 * Raw ADF used to preserve explicit replacement intent after parser defaults are applied.
 * The wrapper remains present when `adf` is undefined, indicating raw data was unavailable.
 */
export type CellKindConversionIntent = { adf: unknown };

type EditorPluginAIEvent = {
	adfResponse?: DocNode | DocNode['content'][number];
	cellKindConversionIntent?: CellKindConversionIntent;
	type: 'complete' | 'stream' | 'error';
};

/**
 * Normalises an event into the shape used by actor.send().
 * Required in editor-plugin-ai and editor-plugin-ai-streaming-orchestrator
 * to ensure that the events are in the same shape as the actor.send() events
 * for backwards compatibility.
 *
 * This can be cleaned up with platform_editor_ai_xstate_migration.
 */
export function normaliseAIExperienceEvent(event: EditorPluginAIEvent):
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			cacheKey: string;
			cellKindConversionIntent?: CellKindConversionIntent;
			markdown: string;
			// eslint-disable-next-line @typescript-eslint/no-empty-object-type
			modelInput: {};
			type: 'complete' | 'stream' | 'error';
	  }
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			cellKindConversionIntent?: CellKindConversionIntent;
			markdown: string;
			type: 'complete' | 'stream' | 'error';
	  }
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			cacheKey: string;
			cellKindConversionIntent?: CellKindConversionIntent;
			// eslint-disable-next-line @typescript-eslint/no-empty-object-type
			modelInput: {};
			type: 'complete' | 'stream' | 'error';
	  } {
	switch (event.type) {
		case 'complete':
			return {
				markdown: '',
				cacheKey: '',
				modelInput: {},
				...event,
			};

		case 'stream':
			return {
				markdown: '',
				...event,
			};

		case 'error':
			return {
				cacheKey: '',
				modelInput: {},
				...event,
			};
	}
}
